export default "__VITE_ASSET__bzM$j5fL__"